'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FireplaceIcon = function FireplaceIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M15 99h100v-2H15zM15 104h100v-2H15z'
                })
            ),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M30.03 26.948h69.796v4.468h-2.89v4.248h3.626v6.087h-3.176v47.796h3.075l.101 7.212H30.525v-6.017h2.471V41.75h-3.224v-5.62h3.065v-3.42h-2.916z'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M66.131 93.82h2.246v-2.252h-2.246zM75.116 93.82h2.246v-2.252h-2.246zM79.608 93.82h2.246v-2.252h-2.246zM48.162 93.82h2.246v-2.252h-2.246zM43.706 93.82h2.21v-2.252h-2.21zM61.639 93.82h2.246v-2.252h-2.246zM84.1 93.82h2.247v-2.252H84.1zM52.654 93.82H54.9v-2.252h-2.246zM57.147 93.82h2.246v-2.252h-2.246zM70.623 93.82h2.247v-2.252h-2.247zM45.916 46.548h2.246v-2.253h-2.246zM36.931 46.548h2.246v-2.253h-2.246zM41.423 46.548h2.247v-2.253h-2.247zM59.393 46.548h2.246v-2.253h-2.246zM68.377 46.548h2.246v-2.253h-2.246zM63.885 46.548h2.246v-2.253h-2.246zM81.854 46.548H84.1v-2.253h-2.246zM77.362 46.548h2.246v-2.253h-2.246zM54.9 46.548h2.247v-2.253H54.9zM72.87 46.548h2.246v-2.253H72.87zM90.839 46.548h2.246v-2.253h-2.246zM50.408 46.548h2.246v-2.253h-2.246zM86.347 46.548h2.246v-2.253h-2.246z'
                }),
                _react2.default.createElement('path', {
                    d: 'M31.334 30.627H98.7v-2.252H31.334v2.252zm2.298 4.506h62.822V32.88H33.632v2.253zm-2.298 4.505H98.7v-2.252H31.334v2.252zm65.12 49.607h-4.492v-25.93a9.75 9.75 0 0 0-7.27-9.437l-19.684-5.15-19.683 5.15a9.75 9.75 0 0 0-7.27 9.437v25.93h-4.422V41.891h62.821v47.354zm2.246 6.822l-6.738.001v-4.57H98.7v4.569zm-8.984.001l-49.416.004V63.315a7.499 7.499 0 0 1 5.591-7.257l19.117-5.003 19.118 5.003a7.498 7.498 0 0 1 5.59 7.257v32.753zm-51.662.004l-6.808.002v-4.576h6.808v4.574zM29.088 32.88h2.299v2.253h-2.3v6.758h2.3v47.354H29v9.081l71.947-.006v-9.075H98.7V41.891h2.247v-6.758H98.7V32.88h2.247v-6.758h-71.86v6.758z'
                }),
                _react2.default.createElement('path', {
                    d: 'M76.333 80.784l-.005-.954c0-3.035-1.657-5.571-2.452-6.79-.105-.16-.196-.298-.265-.413-.279-.455-.355-1.117-.364-1.385a6.438 6.438 0 0 1-.016-.419 5.347 5.347 0 0 1 .706-2.69l1.201-2.098-2.374.43a8.513 8.513 0 0 0-3.078 1.203 13.37 13.37 0 0 1-.183-10.154l1.45-3.734-3.178 2.43a19.216 19.216 0 0 0-7.288 11.983 8.44 8.44 0 0 0-3.762-1.674l-2.377-.413 1.215 2.09c.412.71.648 1.612.722 2.76.1 1.529-.819 2.95-1.142 3.406a11.567 11.567 0 0 0-1.926 6.02l-.008.402c0 2.262.641 4.424 1.835 6.278H43.706v2.253H60.1l-1.917-1.923a9.3 9.3 0 0 1-2.728-6.608l.007-.323a9.312 9.312 0 0 1 1.55-4.848c.503-.708 1.659-2.593 1.515-4.803a11.08 11.08 0 0 0-.165-1.35c.859.488 1.56 1.166 1.98 1.954l1.962 3.68.15-4.17a16.968 16.968 0 0 1 3.995-10.365 15.613 15.613 0 0 0 1.859 9.393l.706 1.268 1.05-1.003a5.64 5.64 0 0 1 1.042-.781 7.569 7.569 0 0 0-.103 1.905c.003.14.044 1.402.692 2.462.08.131.183.29.3.47.73 1.117 2.086 3.195 2.086 5.557l.006.954a9.31 9.31 0 0 1-2.721 6.61l-1.912 1.921h16.894v-2.253H74.503a11.568 11.568 0 0 0 1.83-6.278'
                })
            )
        )
    );
};

FireplaceIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var Fireplace = function (_React$Component) {
    _inherits(Fireplace, _React$Component);

    function Fireplace() {
        _classCallCheck(this, Fireplace);

        return _possibleConstructorReturn(this, (Fireplace.__proto__ || Object.getPrototypeOf(Fireplace)).apply(this, arguments));
    }

    _createClass(Fireplace, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(FireplaceIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return Fireplace;
}(_react2.default.Component);

exports.default = Fireplace;